export function imageUrl(object, { width, height } = {}, { focalX, focalY } = {}) {
    if (typeof object !== 'object') {
        return;
    }

    const src = object.image?.src?.replace(' ', '%20');

    if (!src) {
        return;
    }

    if (!src) {
        console.warn("Image source is required");
    }

    const params = [];
    if (width) params.push(`width=${width}`);
    if (height) params.push(`height=${height}`);
    if (width && height) params.push(`f=cover`);
    if (focalX) params.push(`fx=${focalX}`);
    if (focalY) params.push(`fy=${focalY}`);

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `${src}${queryString}`;
}
